export function getEssResultMessage(score: number) {
    let essResultMessage = '';
    if (score < 6) {
        essResultMessage = 'Normale slaperigheid (laag)';
    } else if (score < 11) {
        essResultMessage = 'Normale slaperigheid (hoog)';
    } else if (score < 13) {
        essResultMessage = 'Lichte slaperigheid';
    } else if (score < 16) {
        essResultMessage = 'Matige slaperigheid';
    } else if (score < 25) {
        essResultMessage = 'Ernstige slaperigheid';
    }

    return essResultMessage;
}
